<div
  class="wrap border-md"
  [ngStyle]="{
    backgroundColor: isOutlined ? 'none' : 'var(--color-' + color + ')',
    border: isOutlined ? '1px solid ' + 'var(--color-' + color + ')' : 'none'
  }"
  [attr.disabled]="disabled || isLoading"
>
  <div
    [ngStyle]="{
      color: isOutlined
        ? 'var(--color-' + color + ')'
        : 'var(--color-on-' + color + ')'
    }"
    class="label"
  >
    {{ label }}
  </div>
  <div *ngIf="endIconName && !isLoading" class="end-icon">
    <app-svg-icon
      [name]="endIconName"
      [color]="isOutlined ? 'color-primary' : 'color-on-primary'"
    ></app-svg-icon>
  </div>
  <div *ngIf="isLoading" class="loader">
    <ion-spinner class=""></ion-spinner>
  </div>
</div>
